import * as yup from "yup";

export const ForgotPasswordFormValidation = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email.")
    .required("Please enter an email."),
});
